export default (typeof window !== 'undefined' && window) as Window;
